import { useState, useEffect } from "react";
import Pagination from "@/components/Pagination";
import { useUserStore } from "@/store";
import {
  useAllMarkNotificationAsRead,
  useMarkNotificationAsRead,
  useNotifications,
} from "@/hooks/useNotification";
import { useNotificationStore } from "@/store/notification.store";
import MultiSelectDropdown from "@/components/CustomInput/MultiDropDown";
import useAuthStore from "@/store/useAuthStore";
import NotificationCard from "@/components/Cards/Notification";
import { formatDateUS } from "@/utils/dateUtils";
import { useDashboardTheme } from "../MeetingDashboard/themeHelper";

const Teams = () => {
  const { isDark } = useDashboardTheme();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const userId = useAuthStore.getState().id;
  const itemsPerPage = 10;
  const { items, setNotifications } = useNotificationStore();
  const { setPageHeader } = useUserStore();
  const { mutate: markAsRead } = useMarkNotificationAsRead();
  const { mutate: markAllAsRead } = useAllMarkNotificationAsRead();
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const { data: apiNotificationsResponse, isLoading: isNotificationsLoading } =
    useNotifications(currentPage, itemsPerPage, selectedStatus);

  useEffect(() => {
    setPageHeader("Notifications");
  }, [setPageHeader]);

  useEffect(() => {
    if (apiNotificationsResponse?.items) {
      setNotifications(apiNotificationsResponse.items);
    }
  }, [apiNotificationsResponse, setNotifications]);

  const handleMarkAllAsRead = () => {
    markAllAsRead(userId);
  };

  const statusOptions = [
    { label: "All", value: "" },
    { label: "Read", value: "false" },
    { label: "Unread", value: "true" },
  ];

  const totalPages = apiNotificationsResponse?.totalPages || 0;

  return (
    <main className={"flex-1 p-4 mt-15 " + (isDark ? "" : "light-theme-dashboard")} style={{ background: isDark ? "" : "#F4F5F7" }}>
      <div className="min-h-[75vh] rounded-xl p-6 mx-auto flex flex-col gap-4 shadow-lg credit-usage-container">
        <div className="flex justify-between items-center">
          <MultiSelectDropdown
            label=""
            options={statusOptions}
            value={selectedStatus}
            onChange={(value) =>
              setSelectedStatus(Array.isArray(value) ? (value[0] ?? "") : value)
            }
            className="!w-60"
            search={false}
            placeholder="Filter"
          />

          <button
            onClick={handleMarkAllAsRead}
            className="w-50 h-10 font-semibold poppins rounded-full transition duration-300 bg-[#B8F890] text-black text-sm px-4 hover:bg-[#A0E87A] disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={items.filter((n) => !n.read).length === 0}
          >
            Mark all as read
          </button>
        </div>

        <div className="h-full bg-[#1C1A26] rounded-lg overflow-hidden credit-usage-card">
          {isNotificationsLoading ? (
            <div className="text-white text-center py-10">Loading...</div>
          ) : items.length === 0 ? (
            <div className="text-white text-center py-10">
              No notifications found.
            </div>
          ) : (
            <div className="flex flex-col divide-y divide-[#333]">
              {items.map((notification) => (
                <NotificationCard
                  key={notification.id}
                  senderName={notification.User?.name || "Unknown"}
                  subject={notification.type.replace(/_/g, " ")}
                  message={notification.message}
                  // avatarUrl={notification}
                  date={formatDateUS(notification.createdAt, true)}
                  isRead={notification.read}
                  onClick={() => {
                    if (!notification.read) {
                      markAsRead(notification.id);
                    }
                  }}
                  time={""}
                />
              ))}
            </div>
          )}

          {totalPages > 1 && items.length > 0 && (
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </div>
      </div>
    </main>
  );
};

export default Teams;
